<label for="osiAddInput" class="weight-medium is-uppercase">
  {{'exception-mode.osi-label' | translate}}</label>

<div class="columns">
  <div class="column control has-icons-right w-100">
    <input
      [class.is-tall]="tall"
      [(ngModel)]="inputValue"
      [ngModelOptions]="{standalone: true}"
      (keydown.enter)="addOsi()"
      class="input"
      type="text"
      id="osiAddInput"
      autocomplete="off"
      [placeholder]="'exception-mode.osi-placeholder' | translate"
      (blur)="addOsi()"
    />
    <span
      class="icon plus is-small is-right has-text-grey has-events"
      (click)="addOsi()"
    >
      <em class="mdi mdi-plus is-size-4 has-pointer-cursor"></em>
    </span>
  </div>
</div>

<div class="columns"  [formGroup]="formGroup">
  <div class="column is-12 field is-grouped is-grouped-multiline"
  formArrayName="osis">
    <div
    class="control max-100"
    *ngFor="let tag of formArray?.controls; let i = index">
    <div class="tags has-addons">
      <span class="tag is-light"> {{ tag.value }}</span>
      <a class="tag is-delete " (click)="delete.emit(i)"></a>
    </div>
  </div>
  </div>
</div>